import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React from 'react';
import dynamic from "next/dynamic";
import {useRouter} from 'next/router';
import Config from '../../config';
import { getStaticPath } from '../../utils';

const CustomerConsent = dynamic(()=> import('../../src/common/components/grievance-redressal/index'),
{loading: () => <p>Loading ...</p>,ssr:true }
);

export async function getServerSideProps() {
  return {
    props: {
      pageName: 'grievance-redressal'
    }

  }
}

export default function Home(props) {
  const router = useRouter()
  const BASE_URL = Config.BASE_URL;
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")
  return (
    <>
      <Head>
        <title>Onsitego’s Grievance Redressal</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content="Contact our GRO for Grievance Redressal. Visit our website for more details."></meta>
        <meta property="og:title" content="Onsitego’s Grievance Redressal"/>
        <meta property="og:description" content="Contact our GRO for Grievance Redressal. Visit our website for more details."/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>
      </Head>
      <PlainBanner title="Grievance Redressal - Onsitego" />
      <CustomerConsent />
    </>
  )
}